/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Analysis_Not_Found_DescriptionInputs */

const en_document_analysis_not_found_description = /** @type {(inputs: Document_Analysis_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The document analysis you are looking for could not be found. Template or document may have been deleted, or you may not have access to it.`)
};

const nl_document_analysis_not_found_description = /** @type {(inputs: Document_Analysis_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De documentanalyse die je zoekt kon niet worden gevonden. Template of document kan zijn verwijderd, of je hebt er mogelijk geen toegang toe.`)
};

/**
* | output |
* | --- |
* | "The document analysis you are looking for could not be found. Template or document may have been deleted, or you may not have access to it." |
*
* @param {Document_Analysis_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const document_analysis_not_found_description = /** @type {((inputs?: Document_Analysis_Not_Found_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Analysis_Not_Found_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_document_analysis_not_found_description(inputs)
	return en_document_analysis_not_found_description(inputs)
});